module.exports = __webpack_public_path__ + "static/media/phone.dd07f03d.png";